module.exports = __webpack_public_path__ + "static/recentProductsLayout1Front-15f74a878d894d3ac7a2c5ede427cad0.png";